<template>
  <div class="modal-body-wrapper">
    <div class="label">
      Industry sector name
    </div>
    <input type="text" placeholder="Name" class="form-item form-item--input">
    <div class="label">
      Activity sectors
    </div>
    <multiselect
      v-model="selectedFields"
      multiple
      :options="multiselectOptions"
      taggable
      @tag="proccessNewTag"
      :close-on-select="false">

    </multiselect>

    <div class="action">
      <button class="btn btn-blue" @click="development">Save</button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  components: {
    'multiselect': () => import('vue-multiselect'),
  },
  props: {
    avalibleOptions: {
      type: Array,
      default: () => Array(),
    },
  },
  data: () => ({
    tags: Array(),
    selectedFields: Array(),
  }),
  computed: {
    multiselectOptions() {
      return [...this.tags, ...this.avalibleOptions];
    },
  },
  methods: {
    proccessNewTag(name) {
      this.tags.unshift(name);
      this.selectedFields.push(name);
    },
    development() {
      this.$root.$emit('notification', {
        message: 'In development',
        type: 'attention',
        show: true,
      });
    },
  },
});
</script>

<style lang="scss">
  .modal-body-wrapper {
    padding: 20px;
    display: flex;
    height: 100%;
    flex-flow: column;

    .label {
      margin: 15px 0;
    }

    .action {
      margin-top: auto;
    }
  }
  .adding-modal {
    .v--modal-box {
      overflow: visible!important;
    }
  }
</style>
